module.exports = __webpack_public_path__ + "static/media/necklace.6728208f.jpg";